'use client';

import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle
} from '@/components/ui/card';
import { TOrganizationFAQ } from '@/services/api/organization-api';
import { Service } from '@/services/api/services-api';
import { currencyFormat } from '@/utils/currency';
import { useTranslation } from 'react-i18next';
import Image from 'next/image';

type Props = {
  service: Service;
  organization: TOrganizationFAQ;
};

const ServiceCard = ({ service, organization }: Props) => {
  const { t } = useTranslation(['newBooking']);

  const price = service.price;
  const recervationPct = service.reservationPct;
  const deposit = price * (recervationPct / 100);
  const imageUrl = service.imageUrl ?? '';

  return (
    <Card key={service.id} className={`flex items-start h-full `}>
      <div>
        <CardHeader className="p-4 md:p-6">
          <CardTitle className="flex items-start justify-between ">
            <span className="text-xl">{service.name}</span>
          </CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col justify-between gap-6 p-4 md:flex-row md:p-6">
          <div className="flex flex-col gap-6 items-center">
            <div>{service.description}</div>
            {imageUrl && (
              <Image
                src={imageUrl}
                width={850}
                height={850}
                style={{ objectFit: 'contain' }}
                alt="Campus de Verano"
              />
            )}
          </div>
        </CardContent>
        {/* <CardFooter>
          <div className="w-full bg-accent p-4 rounded space-y-2">
            <h3 className="font-semibold">{t('features.title')}</h3>
            <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
              <p className="text-sm">
                <span className="font-semibold">{t('features.ages')}:</span>{' '}
                {t('features.from2')}&nbsp;
                {service.minAge} {t('features.to2')} {service.maxAge}{' '}
                {t('features.yearsOld')}
              </p>
              <p className="text-sm">
                <span className="font-semibold">Porcentaje reserva:</span>{' '}
                {recervationPct}%
              </p>
              <p className="text-sm">
                <span className="font-semibold">
                  {t('features.totalPerParticipant')}:
                </span>
                &nbsp;{currencyFormat(price, organization.currency)}
              </p>
              <p className="text-sm">
                <span className="font-semibold">
                  {t('features.depositPerParticipant')}:
                </span>
                &nbsp;{currencyFormat(deposit, organization.currency)}
              </p>
            </div>
          </div>
        </CardFooter> */}
      </div>
    </Card>
  );
};

export default ServiceCard;
